module.exports = __webpack_public_path__ + "static/media/piped gas.52579e9c.png";